import fetchRestData from '../../helpers/fetchResData'

/**
 * Given a flyerId, fetch flyer's gibs total count.
 * Returns the raw { data, metadata } response, count is in metadata.count
 * @param {Object} params
 * @param {string} params.flyerId
 * @param {string} [params.q] - server-side search query, counts only matching gibs
 */

export const fetchFlyerGibsCount = ({ flyerId, q }) => {
  const options = {
    resource: `flyers/${flyerId}/flyer_gibs/count`,
    paginate: false,
    dataOnly: false,
    ...(q ? { params: { q } } : {}),
  }

  return fetchRestData(options)
}
